export const mmtTheme = {
  // Base
  white: '#ffffff',
  colorPrimary: '#2E90FA',
  borderColor: '#EAECF0',

  // Gray
  gray50: '#D2D6DB',

  // Base Gray
  baseGray20: '#f5f5f5',
  baseGray30: '#F3F4F6',
  baseGray40: '#E5E7EB',
  baseGray50: '#D2D6DB',
  baseGray60: '#9DA4AE',
  baseGray70: '#6C737F',
  baseGray80: '#4D5761',
  baseGray90: '#384250',
  baseGray100: '#2B3644',
  baseGray110: '#1F2A37',

  // Primary
  colorPrimary1: '#F5FAFF',
  colorPrimary2: '#EFF8FF',
  colorPrimary3: '#D1E9FF',
  colorPrimary4: '#B2DDFF',
  colorPrimary5: '#84CAFF',
  colorPrimary6: '#53B1FD',
  colorPrimary7: '#2E90FA',
  colorPrimary8: '#1570EF',
  colorPrimary9: '#175CD3',
  colorPrimary10: '#1849A9',

  // Success
  success1: '#F6FEF9',
  success2: '#ECFDF3',
  success3: '#D7FBE5',
  success4: '#B0F3CB',
  success5: '#6AD99E',
  success6: '#32D583',
  success7: '#12B76A',
  success8: '#039855',
  success9: '#05603A',
  success10: '#054F31',

  // Warning
  warning1: '#FFFCF5',
  warning2: '#FFFAEB',
  warning3: '#FEF0C7',
  warning4: '#FEDF89',
  warning5: '#FEC84B',
  warning6: '#FDB022',
  warning7: '#F79009',
  warning8: '#DC6803',
  warning9: '#B54708',
  warning10: '#93370D',

  // Error
  error1: '#FFFBFA',
  error2: '#FEF3F2',
  error3: '#FEE4E2',
  error4: '#FECDCA',
  error5: '#FDA29B',
  error6: '#F97066',
  error7: '#F04438',
  error8: '#D92D20',
  error9: '#B42318',
  error10: '#912018',

  // Red
  red1: '#FFF1F0',
  red2: '#FFCCC7',
  red3: '#FFA39E',
  red4: '#FF7875',
  red5: '#FF4D4F',
  red6: '#F5222D',
  red7: '#CF1322',
  red8: '#A8071A',
  red9: '#820014',
  red10: '#5C0011',

  // Volcano
  volcano1: '#FFF2E8',
  volcano2: '#FFD8BF',
  volcano3: '#FFBB96',
  volcano4: '#FF9C6E',
  volcano5: '#FF7A45',
  volcano6: '#FA541C',
  volcano7: '#D4380D',
  volcano8: '#AD2102',
  volcano9: '#871400',
  volcano10: '#610B00',

  // Orange
  orange1: '#FFF7E6',
  orange2: '#FFE7BA',
  orange3: '#FFD591',
  orange4: '#FFC069',
  orange5: '#FFA940',
  orange6: '#FA8C16',
  orange7: '#D46B08',
  orange8: '#AD4E00',
  orange9: '#873800',
  orange10: '#612500',

  // Gold
  gold1: '#FFFBE6',
  gold2: '#FFF1B8',
  gold3: '#FFE58F',
  gold4: '#FFD666',
  gold5: '#FFC53D',
  gold6: '#FAAD14',
  gold7: '#D48806',
  gold8: '#AD6800',
  gold9: '#874D00',
  gold10: '#613400',

  // Yellow
  yellow1: '#feffe6',
  yellow2: '#ffffb8',
  yellow3: '#fffb8f',
  yellow4: '#fff566',
  yellow5: '#ffec3d',
  yellow6: '#fadb14',
  yellow7: '#d4b106',
  yellow8: '#ad8b00',
  yellow9: '#876800',
  yellow10: '#614700',

  // Lime
  lime1: '#FCFFE6',
  lime2: '#F4FFB8',
  lime3: '#EAFF8F',
  lime4: '#D3F261',
  lime5: '#BAE637',
  lime6: '#A0D911',
  lime7: '#7CB305',
  lime8: '#5B8C00',
  lime9: '#3F6600',
  lime10: '#254000',

  // Green
  green1: '#F6FFED',
  green2: '#D9F7BE',
  green3: '#B7EB8F',
  green4: '#95DE64',
  green5: '#73D13D',
  green6: '#52C41A',
  green7: '#389E0D',
  green8: '#237804',
  green9: '#135200',
  green10: '#092B00',

  // Cyan
  cyan1: '#E6FFFB',
  cyan2: '#B5F5EC',
  cyan3: '#87E8DE',
  cyan4: '#5CDBD3',
  cyan5: '#36CFC9',
  cyan6: '#13C2C2',
  cyan7: '#08979C',
  cyan8: '#006D75',
  cyan9: '#00474F',
  cyan10: '#002329',

  // Blue
  blue1: '#E6F4FF',
  blue2: '#BAE0FF',
  blue3: '#91CAFF',
  blue4: '#69B1FF',
  blue5: '#4096FF',
  blue6: '#1677FF',
  blue7: '#0958D9',
  blue8: '#003EB3',
  blue9: '#002C8C',
  blue10: '#001D66',

  // Primary
  mmtPrimary1: '#F5FAFF',
  mmtPrimary2: '#EFF8FF',
  mmtPrimary3: '#D1E9FF',
  mmtPrimary4: '#B2DDFF',
  mmtPrimary5: '#84CAFF',
  mmtPrimary6: '#53B1FD',
  mmtPrimary7: '#2E90FA',
  mmtPrimary8: '#1570EF',
  mmtPrimary9: '#175CD3',
  mmtPrimary10: '#1849A9',

  // Purple
  purple1: '#F9F0FF',
  purple2: '#EFDBFF',
  purple3: '#D3ADF7',
  purple4: '#B37FEB',
  purple5: '#9254DE',
  purple6: '#722ED1',
  purple7: '#531DAB',
  purple8: '#391085',
  purple9: '#22075E',
  purple10: '#120338',

  // Magenta
  magenta1: '#FFF0F6',
  magenta2: '#FFD6E7',
  magenta3: '#FFADD2',
  magenta4: '#FF85C0',
  magenta5: '#F759AB',
  magenta6: '#EB2F96',
  magenta7: '#C41D7F',
  magenta8: '#9E1068',
  magenta9: '#780650',
  magenta10: '#520339',

  // Sizes
  sizeUnit: 4,
  size: 16,
  sizeXXS: 4,
  sizeXS: 8,
  sizeSM: 12,
  sizeMD: 20,
  sizeLG: 24,
  sizeXL: 40,
  sizeXXL: 30,

  // Padding
  padding: 16,
  paddingXXS: 4,
  paddingXS: 8,
  paddingSM: 12,
  paddingMD: 20,
  paddingLG: 24,
  paddingXL: 32,
  paddingXXL: 48,

  // Margin
  margin: 16,
  marginXXS: 4,
  marginXS: 8,
  marginSM: 12,
  marginMD: 16,
  marginLG: 24,
  marginXL: 48,

  // Height
  controlHeight: 32,
  controlHeightXS: 16,
  controlHeightSM: 24,
  controlHeightLG: 40,

  // Border Radius
  borderRadius: 6,
  borderRadiusXS: 2,
  borderRadiusSM: 4,
  borderRadiusLG: 8,

  // Font Size
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  fontSizeXL: 20,

  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
}
